import React from "react";

function BannerCount() {
  return (
    <div className="px-6 md:px-16 py-6 bg-white flex justify-center">
      <div className="bg-[#013584] text-white flex flex-col md:flex-row gap-10 md:gap-1 items-center justify-between w-full rounded-lg py-6 md:py-10 px-8 md:px-12">
        {/* Learners Section */}
        <div className="flex items-center space-x-2">
          <span className="bg-blue-600 text-white text-xl md:text-2xl lg:text-4xl font-bold px-4 py-2 rounded-md">
            1 Million+
          </span>
          <span className="text-lg">Learners</span>
        </div>

        {/* Divider */}
        <div className="hidden md:block w-px h-10 bg-white opacity-50"></div>

        {/* Hiring Partners Section */}
        <div className="flex items-center space-x-2">
          <span className="text-xl md:text-2xl lg:text-4xl font-bold">100+</span>
          <span className="text-lg">Hiring Partners</span>
        </div>

        {/* Divider */}
        <div className="hidden md:block w-px h-10 bg-white opacity-50"></div>

        {/* Core Skills Section */}
        <div className="flex items-center space-x-2">
          <span className="text-xl md:text-2xl lg:text-4xl font-bold">100+</span>
          <span className="text-lg">Core Skills</span>
        </div>
      </div>
    </div>
  );
}

export default BannerCount;
